import React from "react";
import style from "./editMeasurement.module.scss";
import { Button, Form, TextField } from "../../../primary";
import infoIcon from "../../../../static/images/info.svg";
import { measurementNumber } from "../../../../utils";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";
import Tooltip from "../../../secondary/Tooltip/tooltip";
import { PERMISSIONS } from "../../../../constants/permissions";
import { useEditMeasurementForm } from "./hooks/useEditMeasurementForm";

export const EditMeasurement = ({
  setFormChangesConfirm,
  handleEdit,
  showCancel = false,
  buttonClass = "",
  setMeasurementForm,
  setMeasurementModal,
  editable,
  setEditable,
  setEditBtn,
}) => {
  const { register, handleSubmit, errors, doSubmit, getValue, assessmentDetail, measurementData } = useEditMeasurementForm({
    setMeasurementForm,
    setMeasurementModal,
    editable,
    setEditable,
    setEditBtn,
  });

  return (
    <Form
      setFormChangesConfirm={setFormChangesConfirm}
      onSubmit={handleSubmit(doSubmit)}
      requiredPermission={PERMISSIONS.MEASUREMENT_EDIT}
    >
      <div>
        <TextField
          classes={{
            column: `row mb-3 align-items-center`,
            labelClass: `col-5 ${style.label_spec_edit}`,
            inputColumn: "col-5 p-0",
            inputClassName: `${style.input_field}`,
          }}
          label={
            <div className={`d-inline-flex ${style.label_spec_edit}`}>
              Surface Area (cm
              {assessmentDetail?.isWoundWithoutPhoto === 0 && (
                <sup style={{ top: 0 }}>
                  <b>2</b>
                </sup>
              )}
              ):
              {assessmentDetail?.isWoundWithoutPhoto === 1 && (
                <Tooltip
                  placement="top"
                  className={style.tooltip_Edit}
                  content={
                    <>
                      Surface area is auto-calculated using length <b>x</b> width formula
                    </>
                  }
                >
                  <img src={infoIcon} alt="info" />
                </Tooltip>
              )}
            </div>
          }
          type="number"
          name="surfaceArea"
          defaultValue={getValue("surfaceArea")}
          validator={register(measurementNumber)}
          errors={errors}
          disabled={
            assessmentDetail?.isWoundWithoutPhoto === 0 && assessmentDetail?.woundStage === "resolve" && measurementData?.isMeasurementResolved === 1
              ? false
              : true
          }
        />

        {["length", "width", "depth", "undermining", "tunneling"].map((field) => (
          <TextField
            key={field}
            classes={{
              column: `row mb-3 align-items-center`,
              labelClass: `col-5 ${style.label_spec_edit}`,
              inputColumn: "col-5 p-0",
              inputClassName: `${style.input_field}`,
            }}
            label={field.charAt(0).toUpperCase() + field.slice(1) + " (cm):"}
            type="number"
            id={field}
            name={field}
            defaultValue={getValue(field)}
            validator={register(measurementNumber)}
            errors={errors}
          />
        ))}
      </div>

      <div className="pt-4 pb-3 text-center">
        <Button classes={{ className: `btn ${buttonClass}` }} type="submit">
          {SAVE_BTN}
        </Button>
        {showCancel && (
          <Button type="button" classes={{ className: `btn ${style.cancel_btn}` }} onClick={() => handleEdit("nonEditable", "cancel")}>
            {CANCEL_BTN}
          </Button>
        )}
      </div>
    </Form>
  );
};
